import React, { useState, useEffect } from 'react';
import moment from 'moment';

export default function WeekPickerSundayStart({setSelectedSunday, defaultDate = null}) {
	const [selectedDate, setSelectedDate] = useState(defaultDate);

	useEffect(() => {
		if (defaultDate) {
			const date = moment(defaultDate);
			if (date.isValid()) {
				const formatted = date.format('YYYY-MM-DD');
				setSelectedDate(formatted);
			}
		}
	}, [defaultDate]);

	const handleDateChange = (e) => {
		const input = moment(e.target.value);
		const startOfWeek = moment(input).day(0); // Sunday

		setSelectedSunday(startOfWeek.format("YYYY-MM-DD"))
		setSelectedDate(startOfWeek.format("YYYY-MM-DD"));
	};

	return (
		<div className="week-picker">
			<input
				type="date"
				onChange={handleDateChange}
				value={selectedDate || ''}
				style={{
					height: 36,
					padding: '4px 10px',
					border: '1px solid #ced4da',
					borderRadius: 4,
					maxWidth: 220,
				}}
			/>
			{selectedDate === null && <p style={{ fontStyle: 'italic', marginTop: 6, marginBottom: 0, color: '#777' }}>Select a date to show the week</p> }
		</div>
	);
}
